module.exports = flarum.core.compat['Fragment'];